import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import "./styles.css";
import "antd/dist/antd.css";
import reportWebVitals from "./reportWebVitals";
import { ApolloClientProvider } from "./components/Provider/ApolloClientContext";
import { MonitoringProvider } from "./components/Provider/MonitoringProvider";
import configureStore from "./store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const store = configureStore();

root.render(
  <React.StrictMode>
    <MonitoringProvider>
      <Provider store={store}>
        <ApolloClientProvider>
          <App />
        </ApolloClientProvider>
      </Provider>
    </MonitoringProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
